import { useMutation } from '@tanstack/react-query'
import { PulseFilters } from 'api/pulse'
import { getTopComplimentsCsv } from 'api/pulse/topCompliments'
import fileDownload from 'js-file-download'
import { track } from 'lib/amplitude'

export function useTopComplimentsDownloadCsv(query: PulseFilters) {
  return useMutation({
    mutationFn: async () => {
      track('button_click, pulse_download_csv_top_compliments', {
        filters: query,
      })
      const data = await getTopComplimentsCsv(query)
      fileDownload(data, 'top_compliments.csv')
    },
  })
}
